import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TextField, Grid } from "@mui/material"
import { openPeriodExpenses, closePeriodExpenses } from 'redux/actions/supportExpenses/supportExpensesActions';
import { ModalV2 } from "components/Modal/ModalV2";
import { useToggle } from "hooks/useToggle";
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import RegularButton from "components/CustomButtons/Button";

const ActionsCell = ({ original }) => {
    const dispatch = useDispatch();
    const [description, setDescription] = useState("")
    const [open, handleOpen] = useToggle();

    const handleOnChange = useCallback(({ target }) => {
        setDescription(target?.value)
    }, [])

    const handleCheck = useCallback((e) => {
        e.preventDefault();
        if (original?.status === "OPEN") {
            dispatch(closePeriodExpenses(original?.id, { description }))
        }
        if (original?.status === "CLOSE") {
            dispatch(openPeriodExpenses(original?.id, { description }))
        }
        handleOpen()
    }, [original, description, handleOpen])

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
            {original?.status === "CLOSE" ?
                <RegularButton
                    color="transparent"
                    round
                    onClick={handleOpen}
                    justIcon
                    style={{
                        float: 'right'
                    }}>
                    <EventAvailableIcon color="success" />
                </RegularButton> :
                <RegularButton
                    color="transparent"
                    round
                    onClick={handleOpen}
                    justIcon
                    style={{
                        float: 'right'
                    }}>
                    <EventBusyIcon color="error" />
                </RegularButton>
            }
            <ModalV2
                open={open}
                onClose={handleOpen}
                title={original?.status === "OPEN" ? "Cerrar periodo" : "Abrir periodo"}
                justConfirm
            >
                <Grid container>
                    <Grid item xs={12} sx={{ marginBottom: "1rem" }} >
                        <TextField
                            id="outlined-multiline-flexible"
                            label="Motivo"
                            multiline
                            maxRows={4}
                            fullWidth
                            value={description}
                            onChange={handleOnChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <RegularButton
                            color="danger"
                            onClick={handleOpen}
                            style={{
                                float: 'left'
                            }}>
                            Cancelar
                        </RegularButton>
                        <RegularButton
                            color="info"
                            disabled={!description}
                            onClick={handleCheck}
                            style={{
                                float: 'right'
                            }}>
                            {original?.status === "OPEN" ? "Cerrar" : "Abrir"}

                        </RegularButton>
                    </Grid>
                </Grid>
            </ModalV2>
        </div>
    );
};

export const columns = [
    {
        Header: "Fecha inicial",
        accessor: "start",
        filterable: true,
        filterMethod: (filter, row) => row.start?.toLowerCase().includes(filter.value.toLowerCase())
    },
    {
        Header: "Fecha final",
        accessor: "end",
        filterable: true,
        filterMethod: (filter, row) => row.end?.toLowerCase().includes(filter.value.toLowerCase())
    },
    {
        Header: "Empresa",
        accessor: "company",
        filterable: true,
        filterMethod: (filter, row) => row.company?.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
        Header: "Mes",
        accessor: "month",
        filterable: true,
    },
    {
        Header: "Año",
        accessor: "year",
        filterable: true,
    },
    {
        Header: "Estado",
        accessor: "status",
        filterable: true,
        filterMethod: (filter, row) => String(row.status)?.toLowerCase().includes(filter.value.toLowerCase()),
        Cell: ({ original }) => original.status === "OPEN" ? "Abierto" : original?.status === "CLOSE" ? "Cerrado" : ''
    },
    {
        Header: "Acciones",
        Cell: ({ original }) => <ActionsCell original={original} />,
    }

];
